module.exports = __webpack_public_path__ + "static/media/Volcano.ce0c8e9d.png";